// 책읽기: 기본으로 들어 있는 글(이솝우화)과 글을 읽을 조각으로 나누는 함수.
// 이솝우화는 저작권이 없는 옛 이야기이고, 아래 글은 쉬운 말로 다시 쓴 것이다.

// 한 번에 보드로 보내는 글자 수. 보드 speak.ino 의 SPEAK_MAX_CHARS(80) 보다 작게 한다.
export const BOOK_CHUNK_CHARS = 70;
export const BOOK_MAX_CHARS = 5000; // 책 한 권(입력칸)의 최대 글자 수

export interface OttoBook {
  title: string;
  text: string;
}

export const OTTO_BOOKS: OttoBook[] = [
  {
    title: '토끼와 거북이',
    text:
      '옛날에 토끼와 거북이가 살았어요. 토끼는 달리기를 아주 잘했어요. 그래서 거북이를 늘 놀렸어요. ' +
      '"거북아, 너는 왜 그렇게 느리니?" 화가 난 거북이가 말했어요. "그럼 우리 달리기 시합을 하자!" ' +
      '시합이 시작되었어요. 토끼는 쌩 하고 달려가서 금방 거북이가 보이지 않게 되었어요. ' +
      '토끼는 뒤를 돌아보며 웃었어요. "거북이는 아직 멀었네. 나는 낮잠이나 한숨 자야지." ' +
      '토끼는 나무 그늘에서 쿨쿨 잠이 들었어요. 그동안 거북이는 쉬지 않고 한 걸음 한 걸음 걸었어요. ' +
      '토끼가 눈을 떴을 때, 거북이는 결승선에 거의 다 와 있었어요. 토끼는 놀라서 힘껏 달렸지만 너무 늦었어요. ' +
      '이긴 것은 거북이였어요. 꾸준히 노력하는 사람이 결국 이긴답니다.',
  },
  {
    title: '개미와 베짱이',
    text:
      '더운 여름날, 개미들은 땀을 뻘뻘 흘리며 먹이를 모았어요. 그런데 베짱이는 나무 그늘에서 노래만 불렀어요. ' +
      '"개미야, 같이 놀자. 노래가 얼마나 즐거운데!" 개미가 대답했어요. "겨울에 먹을 음식을 모아야 해. 너도 준비하렴." ' +
      '베짱이는 웃기만 했어요. 곧 찬바람이 불고 눈이 내리기 시작했어요. ' +
      '베짱이는 먹을 것이 하나도 없어서 배가 고프고 몸이 떨렸어요. 그래서 개미네 집을 찾아갔어요. ' +
      '"개미야, 먹을 것을 조금만 나누어 주겠니?" 개미는 베짱이를 따뜻하게 맞아 주었어요. ' +
      '베짱이는 눈물을 흘리며 말했어요. "미안해. 이제는 나도 열심히 준비할게." 미리 준비하는 사람은 어려운 때에도 걱정이 없답니다.',
  },
  {
    title: '양치기 소년',
    text:
      '산 아래 마을에 양을 돌보는 소년이 있었어요. 소년은 심심해서 장난을 치기로 했어요. ' +
      '"늑대가 나타났어요! 도와주세요!" 마을 사람들은 깜짝 놀라 몽둥이를 들고 달려왔어요. ' +
      '하지만 늑대는 없었어요. 소년은 깔깔 웃었어요. 사람들은 화가 나서 돌아갔어요. ' +
      '다음 날 소년은 또 거짓말을 했어요. 사람들은 또 속아서 달려왔어요. ' +
      '며칠 뒤, 진짜 늑대가 나타났어요! 소년은 목이 터져라 소리쳤어요. "늑대예요! 진짜예요! 도와주세요!" ' +
      '그러나 마을 사람들은 또 장난이라고 생각하고 오지 않았어요. 양들은 모두 늑대에게 잡히고 말았어요. ' +
      '소년은 엉엉 울며 후회했어요. 거짓말을 자주 하면 진짜 말을 해도 아무도 믿어 주지 않는답니다.',
  },
  {
    title: '여우와 신 포도',
    text:
      '배고픈 여우가 길을 가다가 높은 포도나무를 보았어요. 가지마다 잘 익은 포도가 주렁주렁 달려 있었어요. ' +
      '"야, 맛있겠다!" 여우는 포도를 따려고 펄쩍 뛰었어요. 하지만 손이 닿지 않았어요. ' +
      '여우는 몇 번이고 힘껏 뛰어올랐지만 포도는 너무 높이 달려 있었어요. 마침내 여우는 지쳐서 주저앉았어요. ' +
      '그러고는 고개를 돌리며 말했어요. "흥, 저 포도는 어차피 시어서 맛이 없을 거야." ' +
      '그리고 터벅터벅 걸어갔어요. 하지 못한 일을 두고 핑계를 대는 것은 좋은 모습이 아니랍니다.',
  },
];

// 글을 읽을 조각으로 나눈다. 문장 끝(. ! ? … 줄바꿈)에서 자르고, 너무 긴 문장은 쉼표나 띄어쓰기에서 자른다.
// 짧은 문장은 limit 안에서 이어 붙여서 문장 사이에 쓸데없이 쉬지 않게 한다.
export function splitBook(text: string, limit: number = BOOK_CHUNK_CHARS): string[] {
  const sentences = (text.replace(/[ \t]+/g, ' ').match(/[^.!?。…\n]+[.!?。…]*/g) || [])
    .map((s) => s.trim())
    .filter((s) => s.length > 0);

  const pieces: string[] = [];
  for (const s of sentences) {
    let rest = s;
    while (rest.length > limit) {
      // limit 이내에서 가장 뒤에 있는 쉼표, 없으면 띄어쓰기에서 자른다
      let cut = Math.max(rest.lastIndexOf(',', limit - 1), rest.lastIndexOf('，', limit - 1));
      if (cut < limit / 3) cut = rest.lastIndexOf(' ', limit);
      if (cut < limit / 3) cut = limit - 1; // 띄어쓰기도 없으면 그냥 자른다
      pieces.push(rest.slice(0, cut + 1).trim());
      rest = rest.slice(cut + 1).trim();
    }
    if (rest) pieces.push(rest);
  }

  const chunks: string[] = [];
  for (const p of pieces) {
    const last = chunks.length - 1;
    if (last >= 0 && chunks[last].length + 1 + p.length <= limit) chunks[last] += ' ' + p;
    else chunks.push(p);
  }
  return chunks;
}
